const generic = {
    themeName: 'generic',
    brand: 'Generic',
    font: {
        main: ['Nunito Sans', 'sans-serif'],
        alternative: ['Inter', 'sans-serif'],
        'alternative-2': ['Poppins', 'sans-serif'],
        'alternative-3': ['Montserrat', 'sans-serif']
    },
    color: {
        primary: {
            '100': '#a2fcc7',
            '300': '#89fab8',
            '500': '#7CFFB2',
            '700': '#56f096',
            '900': '#2ac96c'
        },
        secondary: {
            '100': '#A98CFF',
            '300': '#906df7',
            '500': '#7657F4',
            '700': '#6543f0',
            '900': '#542feb'
        },
        tertiary: {
            '100': '#2a2961',
            '300': '#1f1e57',
            '500': '#1A1953',
            '700': '#151452',
            '900': '#0e0d4f'
        },
        accent: {
            '100': '#a2fcc7',
            '300': '#89fab8',
            '500': '#7CFFB2',
            '700': '#56f096',
            '900': '#2ac96c'
        },
        neutral: {
            '100': '#A0A6C4',
            '300': '#6F78A8',
            '500': '#454E7D',
            '700': '#2B3157',
            '900': '#171B35'
        },
        background: {
            '100': '#2A2E6A',
            '300': '#1A1953',
            '500': '#141238',
            '700': '#0F0B26',
            '900': '#080616'
        },
        success: {
            '100': '#9FF5CE',
            '300': '#5BE4AB',
            '500': '#01D180',
            '700': '#00935A',
            '900': '#016B42'
        },
        warning: {
            '100': '#FFE5B0',
            '300': '#FFC266',
            '500': '#FF9500',
            '700': '#E27625',
            '900': '#7C3F00'
        },
        error: {
            '100': '#FF8FA6',
            '300': '#FB5B78',
            '500': '#FF375F',
            '700': '#E41C44',
            '900': '#8B001C'
        },
        info: {
            '100': '#77CFFC',
            '300': '#5BC7FF',
            '500': '#375DFB',
            '700': '#223FCC',
            '900': '#0E246B'
        },
        text: {
            '100': '#FFFFFF',
            '300': '#9CA3AF',
            '500': '#747da7',
            '700': '#3F4B79',
            '900': '#0C101C'
        },
        highlight: { '1': '#B7C0FF', '2': '#2F2FE4', '3': '#5F73FF', '4': '#1A1953', '5': '#080616' }
    },
    gradients: {
        main: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.tertiary.500', at: '0%' },
                { token: 'color.background.100', at: '100%' }
            ]
        },
        alternative: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.background.100', at: '0%' },
                { token: 'color.background.300', at: '100%' }
            ]
        },
        'alternative-2': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.background.300', at: '0%' },
                { token: 'color.background.700', at: '100%' }
            ]
        },
        'alternative-3': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.secondary.700', at: '0%' },
                { token: 'color.background.100', at: '100%' }
            ]
        },
        'alternative-4': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.background.300', at: '0%' },
                { token: 'color.background.900', at: '100%' }
            ]
        },
        'alternative-5': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.background.300', at: '0%' },
                { token: 'color.background.900', at: '100%' }
            ]
        },
        'alternative-6': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.background.100', at: '0%' },
                { token: 'color.background.700', at: '100%' }
            ]
        },
        primary: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.primary.100', at: '0%' },
                { token: 'color.primary.500', at: '100%' }
            ]
        },
        'primary-2': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.primary.100', at: '0%' },
                { token: 'color.primary.500', at: '100%' }
            ]
        },
        'primary-dark': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.primary.500', at: '0%' },
                { token: 'color.primary.900', at: '100%' }
            ]
        },
        secondary: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.secondary.500', at: '0%' },
                { token: 'color.secondary.700', at: '100%' }
            ]
        },
        'secondary-light': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.secondary.300', at: '0%' },
                { token: 'color.secondary.500', at: '100%' }
            ]
        },
        accent: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.accent.300', at: '0%' },
                { token: 'color.accent.500', at: '100%' }
            ]
        },
        success: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.success.500', at: '0%' },
                { token: 'color.success.900', at: '100%' }
            ]
        },
        error: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.error.500', at: '0%' },
                { token: 'color.error.700', at: '100%' }
            ]
        },
        'error-2': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.error.300', at: '0%' },
                { token: 'color.error.700', at: '100%' }
            ]
        },
        christmas: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'christmas.2', at: '0%' },
                { token: 'christmas.1', at: '100%' }
            ]
        },
        'christmas-2': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'christmas.3', at: '0%' },
                { token: 'christmas.4', at: '100%' }
            ]
        }
    },
    borderRadius: {
        button: { default: '12px', small: '8px' },
        input: { default: '16px', message: '8px' },
        header: { chatNotifications: '12px', profile: '12px', toggle: '12px', vip: '12px' },
        promotions: { item: '8px' }
    },
    components: {
        error: { background: 'color.error.500', text: 'color.text.100' },
        footer: { social: 'color.neutral.900' },
        info: { background: 'color.info.500', text: 'color.text.100' },
        input: {
            background: 'color.background.300',
            border: 'color.neutral.900',
            'border-hover': 'color.secondary.500',
            'border-active': 'color.primary.500'
        },
        progress: {
            background: 'color.background.500',
            'background-2': 'color.background.500',
            fill: 'color.primary.500',
            'fill-2': 'color.highlight.2',
            'fill-2-shadow': 'color.highlight.2',
            'fill-shadow': 'color.primary.500'
        },
        success: { background: 'color.success.500', text: 'color.text.100' },
        table: { 'odd-row': 'color.background.500' },
        warning: { background: 'color.warning.500', text: 'color.text.900' }
    },
    boxShadows: {
        neutral: '0px -5px 6px 0px #00000040 inset, 0px 5px 6px 0px #ffffff40 inset',
        inner: 'none',
        vip: '0px 0px 8px 0px #ffffff7a'
    },
    maxHeight: { zero: '0', full: '100%' },
    transitions: { maxHeight: 'max-height', rotate: 'transform' },
    rotate: { '360': '360deg' },
    width: { fitContent: 'fit-content', width15: '3.70rem', chatWidth: '340px' },
    height: { height15: '3.70rem' },
    screens: { xs390: '390px', customSm: '580px', custom720: '720px' },
    christmas: {
        '1': '#B00404',
        '2': '#FD5757',
        '3': '#FED234',
        '4': '#FF952B',
        '5': '#61370D',
        '6': '#FF9E14',
        '7': '#1C3899'
    },
    vip: { '1': 'color.highlight.3', '2': 'color.highlight.3' }
};
export default generic;
